import { BrowserRouter, Route, Routes } from "react-router-dom";

import React from 'react'
import Login from "./Screens/Login/Login";
import UserDetails from "./Screens/UserDetails/UserDetails";
import SearchDatabase from "./Screens/SearchDatabase/SearchDatabase";
import SearchDatabaseDetails from "./Screens/SearchDatabase/SearchDatabaseDetails";
import UploadFile from "./Screens/UploadFile/UploadFile";
import DocumentInteraction from "./Screens/UploadFile/DocumentInteraction";

function App() {

  return (
  <BrowserRouter>
  <Routes>
    <Route path="/" element={<Login/>} />
    <Route path="/home" element={<UserDetails/>} />
    <Route path="/search-database" element={<SearchDatabase/>} />
    <Route path="/search-database-details" element={<SearchDatabaseDetails/>} />
    <Route path="/upload-file" element={<UploadFile/>} />
    <Route path="/document-interaction" element={<DocumentInteraction/>} />
    </Routes></BrowserRouter>
  )
}

export default App